import React, {useState} from 'react'
import { BsChevronDown } from 'react-icons/bs'
import './Action.css'

const Butnaction = ({clickedval, actionsta}) => {
    const [view, setView] = useState(false)
    const [value, setValue] = useState('None')
    const handleClick = () =>{
        setView(!view)
    }

    const handlenotClick = () =>{
        // do nothing
    }

    const handleSelect = (e) =>{
        setValue(e.target.outerText)
        clickedval(e.target.outerText)
        setView(false)
    }
    
  return (
    <div className='action-main-container'>
        <div className='action-container' onClick={actionsta ? handleClick : handlenotClick}>
            <BsChevronDown id='action-chevrondwn'/>
            <span>{value}</span>
        </div>
        {view && <div className='action-dropdwn-container'>
            <span id='action-dropdwn' onClick={e => handleSelect(e)}>None</span>
            <span id={actionsta ?  'action-dropdwn' : 'action-dropdwn-disable'} onClick={e => handleSelect(e)}>Completed</span>
            <span id={actionsta ?  'action-dropdwn' : 'action-dropdwn-disable'} onClick={e => handleSelect(e)}>Excalate</span>
            <span id={actionsta ?  'action-dropdwn' : 'action-dropdwn-disable'} onClick={e => handleSelect(e)}>Request Ext.</span>
        </div>}
    </div>
  )
}

export default Butnaction